/**
 * @author Fernando Ruano
 * @file index.js
 * @description Menu Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { menu: menuEndpoints, permission: permissionEndpoints } = endpoints;

export class MenuService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get menus list with pagination
   * @return { Object } - Get menus list.
   */
  getMenus = async () => {
    const url = menuEndpoints.base;
    return this.http.get(url);
  };

  /**
   * Get menu info by user
   * @param { string } userName - Menu by User.
   * @return { Object } - Get menus list.
   */
  getMenuByUser = async (userName) => {
    const body = userName;
    const url = menuEndpoints.byUser;
    return this.http.post(url, body);
  };

  /**
   * Get menu info by role
   * @param { string } roleId - Role id.
   * @return { Object } - Get menus list.
   */
  getMenuByRole = async (roleId) => {
    const url = `${menuEndpoints.byRole}${roleId}`;
    return this.http.get(url);
  };

  /**
   * Get main menu info by role
   * @param { string } roleId - Role id.
   * @return { Object } - Get menus list.
   */
  getMainMenuByRole = async (roleId) => {
    const url = `${menuEndpoints.byRoleMenu}/${roleId}`;
    return this.http.get(url);
  };

  /**
   * Get permissions list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get permissions list.
   */
  getAllPermissions = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = permissionEndpoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };
}

export default new MenuService(externalConnector);
